import { defineStore } from 'pinia'

export const useIntroStore = defineStore('intro', {
  state: () => ({
    mountedSlides: [] as HTMLElement[],   // Håller alla index för mountade slides
    activeIndex: 0                   // Håller aktuell aktiv slide-index
  }),
  actions: {
    registerSlide(slide: HTMLElement) {      
        this.mountedSlides.push(slide)      
    },
    setActiveIndex(index: number) {
      this.activeIndex = index
    },
    resetSlides() {
      this.mountedSlides = [];
      this.activeIndex = 0;
    },
    getSlideIndex(slide: HTMLElement) {
      return this.mountedSlides.indexOf(slide);
    }

  },
  getters: {
    totalSlides: (state) => state.mountedSlides.length,
    isActive: (state) => (index: number) => state.activeIndex === index
  }
})